import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/ordens-de-compra',
  component: mainComponent,
  title: 'Ordens de Compra',
  children: [{
      path: '/',
      name: 'purchaseOrder-list',
      component: () => import('@/views/purchaseOrder/PurchaseOrdersList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Ordens de Compra', active: true },
        ],
        pageTitle: 'Ordens de Compra',
        rule: 'editor'
      },
    },
    {
      path: 'novo',
      name: 'purchaseOrder-new',
      component: () => import('@/views/purchaseOrder/NewPurchaseOrder.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Ordens de Compra', url: '/ordens-de-compra' },
          { title: 'Nova', active: true },
        ],
        pageTitle: 'Ordem de Compra',
        rule: 'editor'
      },
    },
    {
      path: 'editar/:idPurchaseOrder',
      name: 'purchaseOrder-edit',
      component: () => import('@/views/purchaseOrder/EditPurchaseOrder.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Ordens de Compra', url: '/ordens-de-compra' },
          { title: 'Visualizar', active: true },
        ],
        pageTitle: 'Ordem de Compra',
        rule: 'editor'
      },
    },
    {
      path: 'anexar/:idPurchaseOrder',
      name: 'purchaseOrder-attach',
      component: () => import('@/views/purchaseOrder/AttachPurchaseOrder.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Ordens de Compra', url: '/ordens-de-compra' },
          { title: 'Anexar', active: true },
        ],
        pageTitle: 'Anexar Arquivos',
        rule: 'editor'
      },
    }
  ],
}, ];